export const isValidURL = (str: string): boolean => {
  const pattern = /^(https?:\/\/|www\.)?[\w.-]+\.[a-z]{2,}(\/\S*)?$/i;
  return pattern.test(str);
};
